import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { colors, weights } from '~/styles';

const Styled = {
  List: styled.div`
    background: ${colors.grey5};
    border-radius: 8px;
    padding: 1rem 0 4rem 0;
    width: 20rem;
    border: 2px solid ${colors.grey10};
    flex-shrink: 0;

    ${({ isDraggedOver }) =>
      isDraggedOver &&
      css`
        border: 2px dashed ${colors.primary};
      `}
  `,

  ListHeader: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    padding: 0 1rem;
  `,

  ListTitle: styled.h3`
    font-size: 1rem;
    user-select: none;
    font-weight: ${weights.bold};
  `,

  ListContent: styled.div`
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0.75rem 0.5rem 0.75rem 0.5rem;
    overflow-y: auto;
    scrollbar-width: thin;
  `,
};

export default function List({ id, ...props }) {
  const ref = useRef();
  const [isDraggedOver, setIsDraggedOver] = useState(false);

  useEffect(() => {
    return combine(
      dropTargetForElements({
        element: ref.current,
        onDragStart: () => setIsDraggedOver(true),
        onDragEnter: () => setIsDraggedOver(true),
        onDragLeave: () => setIsDraggedOver(false),
        onDrop: () => setIsDraggedOver(false),
        getData: () => ({ type: 'list', id }),
        getIsSticky: () => true,
      }),
    );
  }, [id]);

  return <Styled.List ref={ref} {...props} isDraggedOver={isDraggedOver} />;
}

function ListContent(props) {
  const ref = useRef();

  useEffect(() => {
    return autoScrollForElements({
      element: ref.current,
    });
  });

  return <Styled.ListContent ref={ref} {...props} />;
}

List.Header = Styled.ListHeader;
List.Title = Styled.ListTitle;
List.Content = ListContent;
